
export default class FormAssets {

	static init() {
		return new FormAssets();
	}

	constructor() {
		window.assetsHandler = this.assetsHandler;
	}

	assetsHandler() {
		return {
			selectedImage: null,
			fileNames: [],
			files: [],

			clearSelection() {
				this.fileNames = null;
				this.files = [];
			},

			loadImage() {
				var reader = new FileReader();
				reader.onload = (e) => {
					this.selectedImage = 'url(' + e.target.result + ')';
				};

				if (this.files?.length > 0)
					reader.readAsDataURL(this.files[0]);
				else this.selectedImage = null;
			},

			selectedFilesChanged(input) {
				this.files = Object.values(input.files);
				if (input.accept.includes('image'))
					this.loadImage();
			},
		}
	}
}